import { type IconBaseProps } from 'react-icons';
import { LuLoader } from 'react-icons/lu';

import { cn } from '@/lib/utils';

function Spinner({ className, ...props }: IconBaseProps) {
  return (
    <LuLoader
      role="status"
      aria-label="Loading"
      className={cn('size-4 animate-spin', className)}
      {...props}
    />
  );
}

export { Spinner };
